<template>
  <div>
    <ModalCampaignDelete
      v-bind="{ campaignId, deleting }"
      v-on="{ submit: handleCampaignDelete }"
    />
  </div>
</template>

<script>
import { campaignMethods } from '@/store/helper';
import ModalCampaignDelete from '@/components/Campaigns/ModalCampaignDelete.vue';
import { middleware } from '@/routes/guards';

export default {
  name: 'CampaignDelete',
  components: {
    ModalCampaignDelete,
  },
  props: {
    campaignId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
  }),
  beforeRouteEnter: middleware('account-permission:delete campaigns'),
  methods: {
    ...campaignMethods,
    handleCampaignDelete(campaignId) {
      this.deleting = true;
      this.deleteCampaign({ campaignId })
        .then(() => {
          this.deleting = false;
          this.redirectToCampaignList();
        })
        .catch(() => {
          this.deleting = false;
        });
    },
    redirectToCampaignList() {
      this.$router.replace({ name: 'accounts.campaigns' });
    },
  },
};
</script>
